<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar
        v-show="!!title"
        :color="options.color"
        dense
        flat
        dark
      >
        <v-toolbar-title class="white--text">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        v-show="!!message"
        class="pl-4"
      >
        {{ message }}
      </v-card-text>
      <v-card-actions :class="{ 'pt-4' : !message }">
        <v-spacer/>
        <v-btn
          color="grey"
          text
          flat
          @click.native="agree"
        >
          {{ $t('Yes, that\'s fine') }}
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          flat
          @click.native="cancel"
        >
          {{ $t('Cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
   * Vuetify Confirm Dialog component
   *
   * Insert component where you want to use it:
   * <confirm ref="confirm"></confirm>
   *
   * Call it:
   * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
   * Or use await:
   * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
   *   // yes
   * }
   * else {
   *   // cancel
   * }
   *
   * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
   * <template>
   *   <v-app>
   *     ...
   *     <confirm ref="confirm"></confirm>
   *   </v-app>
   * </template>
   *
   * mounted() {
   *   this.$root.$confirm = this.$refs.confirm.open
   * }
   */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 400
    }
  }),

  methods: {
    open (title, message, options) {
      this.resolve = null
      this.reject = null
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    agree () {
      this.resolve(true)
      this.dialog = false
    },

    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
